// src/components/ExerciseCard.js
import "./ExerciseCard.css";

function MusclePills({ muscleGroup, muscleGroupId }) {
  const left = (muscleGroup ?? "").trim();
  const fallback = (muscleGroupId ?? "").trim();
  if (!left && !fallback) return null;

  return (
    <div className="plan-pill-row">
      <span className="plan-pill">{left || fallback}</span>
    </div>
  );
}

function RepsBadge({ reps }) {
  if (reps == null || Number.isNaN(Number(reps))) return null;
  const n = Number(reps);
  if (n <= 0) return null;

  return (
    <span className="plan-reps-badge">
      <span className="plan-reps-num">{n}</span>
      <span className="plan-reps-label">reps</span>
    </span>
  );
}

function fmtBreak(restSeconds) {
  const s = Number(restSeconds);
  if (!Number.isFinite(s) || s <= 0) return null;
  if (s < 60) return `${s}s`;
  const m = Math.round(s / 60);
  return `${m} min`;
}

export function ExerciseCard({ name, muscleGroup, muscleGroupId, reps }) {
  return (
    <div className="plan-node-card glass">
      <div className="plan-node-top">
        <div className="plan-node-title-row">
          <RepsBadge reps={reps} />
          <div className="plan-node-title">{name}</div>
        </div>

        <div className="plan-node-right">
          <MusclePills muscleGroup={muscleGroup} muscleGroupId={muscleGroupId} />
        </div>
      </div>
    </div>
  );
}

/**
 * ✅ Break card uses the SAME outer box styles as ExerciseCard:
 * - plan-node-card glass
 * - same padding / radius / border
 *
 * Only inner layout differs.
 */
export function BreakCard({ restSeconds = 120 }) {
  const label = fmtBreak(restSeconds);
  if (!label) return null;

  return (
    <div className="plan-node-card glass plan-break-inline">
      <div className="plan-break-inline__left">Break</div>
      <div className="plan-break-inline__right">⏱ {label}</div>
    </div>
  );
}

export function EmptyPlanCard() {
  return (
    <div className="plan-repeat-box glass">
      <div className="plan-repeat-header">
        <span className="plan-repeat-badge">No exercises planned</span>
      </div>

      <div className="plan-node-card glass">
        <div className="plan-node-top">
          <div className="plan-node-title-row">
            <div className="plan-node-title">Tap + to add your first exercise.</div>
          </div>
        </div>
      </div>
    </div>
  );
}